import React from "react";
import { Link } from "react-router-dom";
import { ShieldQuestion, BookOpen, Scale, Link as LinkIcon } from "lucide-react";

const PRINCIPLES = [
  { id: "skepticism", icon: ShieldQuestion, title: "Skepticism by default", body: "We don't treat any narrative — mainstream or fringe — as sacred. Every claim is hedged, sourced, and open to revision." },
  { id: "sources", icon: BookOpen, title: "Real sources only", body: "Every dossier links to working, publicly-indexed sources from major outlets, academic journals, primary documents, or official reports." },
  { id: "balance", icon: Scale, title: "Balanced framing", body: "We surface multiple perspectives — mainstream, skeptical, investigative, primary — and tag each source by its stance." },
  { id: "trail", icon: LinkIcon, title: "Trace the trail yourself", body: "Don't believe a word. Click the sources. Read the originals. Form your own conclusions." },
];

const About = () => (
  <div className="max-w-4xl mx-auto px-6 md:px-12 py-16" data-testid="about-page">
    <div className="font-mono text-[10px] tracking-[0.3em] text-[#D92D20] mb-3">// METHODOLOGY</div>
    <h1 className="font-display text-5xl md:text-6xl text-[#E4DFD3] mb-6">About the Archive</h1>
    <p className="text-lg text-[#A39E93] leading-relaxed mb-12 max-w-3xl">
      THE ARCHIVE is an independent dossier of contested narratives — the topics
      the internet argues about endlessly but rarely sources rigorously.
      Each file pairs an honest summary with the under-reported angle and a
      trail of citations you can follow yourself.
    </p>

    <div className="grid md:grid-cols-2 gap-px bg-[#2D2A26] border border-[#2D2A26]">
      {PRINCIPLES.map((b) => (
        <div key={b.id} className="bg-[#131313] p-8">
          <b.icon size={20} className="text-[#D92D20] mb-3" />
          <h3 className="font-heading text-2xl text-[#E4DFD3] mb-2">{b.title}</h3>
          <p className="text-sm text-[#A39E93] leading-relaxed">{b.body}</p>
        </div>
      ))}
    </div>

    <div className="mt-16 border border-[#2D2A26] bg-[#131313] p-8 relative tape-deco">
      <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#D92D20] mb-3">// EDITORIAL DISCLAIMER</div>
      <p className="text-[#A39E93] leading-relaxed">
        The Archive is editorial commentary aggregated from public sources using
        large language models as a research assistant. It is <span className="text-[#E4DFD3]">not</span> peer-reviewed
        journalism. Treat every dossier as a starting point — not an ending one.
        Click the sources. Read the originals. Truth is rarely tidy.
      </p>
    </div>

    <div className="mt-12 text-center">
      <Link
        to="/archive"
        data-testid="about-cta-btn"
        className="inline-flex items-center gap-2 bg-[#D92D20] hover:bg-[#B92318] text-white px-7 py-3.5 font-mono text-xs uppercase tracking-[0.25em]"
      >
        Enter the Archive
      </Link>
    </div>
  </div>
);

export default About;
